import moment from 'moment'
import { useMemo } from 'react'

export const useGetFullDateTime = (
  date: string | null,
  time: string | null,
): string | null => {
  return useMemo(() => {
    if (!!date && !!time) {
      const datePart = moment(date).format('YYYY-MM-DD')
      return `${datePart}T${time}:00`
    } else if (!!date && !time) {
      return date
    } else {
      return null
    }
  }, [date, time])
}
